/*! Copyright (c) Safe As Milk. All rights reserved. */
class DynamicButton extends HTMLElement {
    #mutationObserver;
    constructor() {
        super();
        this.#mutationObserver = null;
    }
    connectedCallback() {
        // Norwegian fallback for Shopify's light-DOM label; preserve the native link and behavior.
        if (document.documentElement.lang === "no") {
            const localizeMoreOptions = () => {
                this.querySelectorAll("more-payment-options-link a.shopify-payment-button__more-options").forEach(link => {
                    if (link.textContent.trim() === "More payment options") {
                        link.textContent = "Flere betalingsalternativer";
                    }
                });
            };
            this.#mutationObserver = new MutationObserver(localizeMoreOptions);
            this.#mutationObserver.observe(this, { childList: true, subtree: true, characterData: true });
            localizeMoreOptions();
        }
        if (this.children.length > 1) {
            const payNowButtonContainer = this.children[this.children.length - 1];
            const config = {
                attributes: false,
                childList: true,
                subtree: true
            };
            const callback = (mutationList, observer) => {
                if (mutationList.some((mutation => mutation.type === "childList"))) {
                    const placeholderButton = this.querySelector(".dynamic-button__placeholder");
                    if (placeholderButton) {
                        placeholderButton.remove();
                    }
                    observer.disconnect();
                }
            };
            const buttonLoadObserver = new MutationObserver(callback);
            buttonLoadObserver.observe(payNowButtonContainer, config);
        }
    }
    disconnectedCallback() {
        if (this.#mutationObserver) {
            this.#mutationObserver.disconnect();
        }
    }
}

customElements.define("dynamic-button", DynamicButton);
//# sourceMappingURL=dynamic-button.js.map
